import moment from "moment";

// helper function to check if a string is a valid ISO 8601 date format
// and convert it to a JavaScript Date object, otherwise return original value
export const parseDateString = dateString => {
  // check for full ISO format
  if (moment(dateString, moment.ISO_8601, true).isValid()) {
    return moment(dateString).toDate();
  }
  // check for date-only format
  if (moment(dateString, "YYYY-MM-DD", true).isValid()) {
    return moment(dateString, "YYYY-MM-DD").toDate();
  }
  return dateString; // if not a date, return the original value
};

// helper function to set scale dynamically based on data type
export const determineScaleType = (data, key) => {
  // If any entry has a Date, set scale to "time"
  if (data.some(d => d[key] instanceof Date)) {
    return "time";
  }

  // If any entry has a number, set scale to "linear"
  if (data.some(d => typeof d[key] === "number")) {
    return "linear";
  }

  // If any entry has a boolean, set scale to "ordinal"
  if (data.some(d => typeof d[key] === "boolean")) {
    return "ordinal";
  }

  // If any entry has a non-null string, set scale to "ordinal"
  if (data.some(d => typeof d[key] === "string" && d[key] !== null)) {
    return "ordinal";
  }

  // Default to "ordinal"
  return "ordinal";
};
